module.exports = __webpack_public_path__ + "img/002-instagram.15bc5470.svg";